import { assertNotNull } from '../../../helpers/nullHelpers';
import { numericInputStringToNumber } from '../../../helpers/stringHelpers';
import { HeatPumpFormModel } from '../quote-or-design-form/heat-pump/heatPumpFormModel';
import {
  GroundCollectorTypeCode,
  HeatPumpTypeCode,
  SwimmingPoolTypeCode,
} from '../quote-or-design-form/quoteOrDesignFormData';

export type CreateUpdateHeatPumpDto = {
  heatPumpTypeCode: HeatPumpTypeCode;
  groundCollectorTypeCode: GroundCollectorTypeCode | null;
  groundCollectorLengthInMetres: number | null;
  closestMicrogenerationCertificationSchemeLocationName: string | null;
  isCoastalLocation: boolean;
  shouldAddUserHeatEmitter: boolean;
  hasPrivateWaterSupply: boolean;
  areaInMetresSquared: number | null;
  heatLossRateInWattsPerSquareMetre: number | null;
  buildingHeatLoadInKilowatts: number | null;
  swimmingPoolTypeCode: SwimmingPoolTypeCode;
  swimmingPoolEnergyConsumptionInKilowattHours: number | null;
  swimmingPoolPowerInKilowatts: number | null;
  heatPumpUnitPartIds: Array<number>;
  dockingCode: string | null;
  supportOptionPartId: number;
};

export const mapHeatPumpFormModelToDto = (formModel: HeatPumpFormModel): CreateUpdateHeatPumpDto => ({
  heatPumpTypeCode: formModel.heatPumpTypeCode,
  groundCollectorTypeCode:
    formModel.heatPumpTypeCode === 'GroundSourceWithGroundLoops' ? formModel.groundCollectorTypeCode : null,
  groundCollectorLengthInMetres:
    formModel.heatPumpTypeCode === 'GroundSourceWithGroundLoops'
      ? numericInputStringToNumber(formModel.groundCollectorLengthInMetres)
      : null,
  closestMicrogenerationCertificationSchemeLocationName:
    formModel.closestMicrogenerationCertificationSchemeLocation?.name ?? null,
  isCoastalLocation: formModel.heatPumpTypeCode === 'AirSource' && formModel.isCoastalLocation,
  shouldAddUserHeatEmitter: formModel.heatPumpTypeCode === 'AirSource' && formModel.shouldAddUserHeatEmitter,
  hasPrivateWaterSupply: formModel.heatPumpTypeCode === 'AirSource' && formModel.hasPrivateWaterSupply,
  areaInMetresSquared: numericInputStringToNumber(formModel.areaInMetresSquared),
  heatLossRateInWattsPerSquareMetre: numericInputStringToNumber(formModel.heatLossRateInWattsPerSquareMetre),
  buildingHeatLoadInKilowatts: numericInputStringToNumber(formModel.buildingHeatLoadInKilowatts),
  swimmingPoolTypeCode: formModel.swimmingPoolTypeCode,
  swimmingPoolEnergyConsumptionInKilowattHours:
    formModel.swimmingPoolTypeCode === 'None'
      ? null
      : formModel.swimmingPoolEnergyConsumptionInKilowattHours === ''
      ? 0
      : assertNotNull(numericInputStringToNumber(formModel.swimmingPoolEnergyConsumptionInKilowattHours)),
  swimmingPoolPowerInKilowatts:
    formModel.swimmingPoolTypeCode === 'None'
      ? null
      : formModel.swimmingPoolPowerInKilowatts === ''
      ? 0
      : assertNotNull(numericInputStringToNumber(formModel.swimmingPoolPowerInKilowatts)),
  heatPumpUnitPartIds: formModel.heatPumpUnitParts
    .filter(partId => partId != null)
    .map(assertNotNull)
    .map(part => part.partId),
  dockingCode: formModel.dockingCode,
  supportOptionPartId: assertNotNull(formModel.supportOptionPartId),
});
